import { request } from '@tencent/ppd-base-libs';

/**
 *  批量获取商户信息
 * @param spidList 商户列表
 * @returns
 */
export async function getMallBasicInfoByIds(spidList: string[]) {
  const url = '/app/promotion/we_coupon/we_coupon_multi_sp_info.cgi';
  const res = await request.get(url, { params: { spids: spidList.join('|') } });
  const list = (res?.sp_array || []) as Array<Record<string, string>>;

  return list.map(item => ({
    id: item.spid,
    logo: item.sp_logo,
    name: item.sp_name,
  }));
}
